<sl-title title="User Details"></sl-title>
<a [routerLink]="['/lsb/systemSettings/users']"
	class="linq-button--primary export-button mx-1 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base mb-2">Back
	To Users</a>
<sl-form [form]="form" [fields]="fields" [model]="model" [options]="options">
	<sl-button-bar *ngIf="formHasChanges" (canceled)="cancelChanges()" (submitted)="saveChanges()" [saveDisabled]="formIsInvalid"></sl-button-bar>
</sl-form>